<template>
  <div id="app">
    <!-- 核心：这个标签是路由的占位符！ -->
    <!-- 路由匹配到谁（比如 Login 或 Layout），这里就会渲染谁 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 既然是打包成手机 APP，这里顺便帮你做个全局防滑和边距清零 */
html, body, #app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #f7f8fa; /* 淡淡的灰色背景，更像手机系统 */
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica,
    Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei',
    sans-serif;
}
</style>